import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';
import clsx from 'clsx';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(13);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const Remove = ({ className, fill = '#DC0032' }) => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 13 13" className={clsx(styles.icon, className)}>
      <rect width="13" height="13" fill={fill} />
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.85709 5.62952H11.1428V7.37059H1.85709V5.62952Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(Remove);
